/**
 * Fill-level palette shared by the dashboard progression chart and the
 * consumers-table filter chips, so both render the same visual scale.
 */
export const LOYALTY_CARD_FILL_COLORS = ["#cecece", "#9d80f5", "#3513e2", "#419e83"];

/**
 * Gender colors shared by the dashboard charts (donut + age pyramid).
 * `unknown` renders the members whose gender is not filled in.
 */
export const LOYALTY_CARD_GENDER_COLORS = {
    female: "#FF80A2",
    male: "#3513e2",
    unknown: "#e5e7eb"
} as const;
